<template>
  <div class="p-4">
    <div class="max-w-2xl mx-auto space-y-6">
      <ScrollbarPreferenceSetting />
    </div>
  </div>
</template>
